import { render, staticRenderFns } from "./LoaderText.vue?vue&type=template&id=25b276c0&"
import script from "./LoaderText.vue?vue&type=script&lang=js&"
export * from "./LoaderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports